import {connect} from 'react-redux'
import {
    ActionsRow,
    commons,
    FixedDropDownButton,
    Icon,
    Loader,
    modal,
    utils
} from "@mc/mc-legacy";
import {Button, ButtonToolbar, CardBody, Col, DropdownItem, Row} from "reactstrap";
import AdminPage from "./AdminPage";
import * as ciselnikActions from "../../actions/ciselnikActions";
import CiselnikApi from "../../api/gen/cgo/CiselnikApi";
import SazbaDphForm from "../../forms/SazbaDphForm";
const {sinkEvent} = commons;
import TablePanel from "../../components/TablePanel";
import CustomCheckbox from "../../components/CustomCheckbox";
import {Component} from "react";
import * as React from "react";
import {withTranslation, WithTranslation} from "react-i18next";

const COLUMN_WIDTH = 3;

/**
 * Stránka administrace - Sazby DPH
 */
class SazbyDphPage extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        this.props.dispatch(ciselnikActions.fetchSazbyDphIfNeeded());
    };

    handleCreateSazbaDph = () => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SazbaDphForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.createDan(data);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateSazbyDph());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('admin.new_vat_rate'),
            {size: "md"}
        ));
    };

    handleEditSazbaDph = (sazba) => {
        const {t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            SazbaDphForm,
            {
                onSubmit: (data) => {
                    return CiselnikApi.updateDan(data, data.id);
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                    dispatch(ciselnikActions.invalidateSazbyDph());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
                initialValues: sazba
            },
            t('admin.vat_rate_change'),
            {size: "md"}
        ));
    };

    handleVcetneNeaktivnich = (e) => {
        const {sazbyDphList} = this.props;
        this.props.dispatch(ciselnikActions.filterSazbyDph({
            ...sazbyDphList.filter,
            vcetneNeaktivnich: e.target.checked
        }, false));
    };

    renderContextMenu = (sazba) => {
        const {t} = this.props;
        return <FixedDropDownButton color="action action-hover" noCaret title={<Icon icon="ellipsis-v"/>}>
            <DropdownItem key="0" onClick={sinkEvent(this.handleEditSazbaDph.bind(this, sazba))}>{t('edit')}</DropdownItem>
        </FixedDropDownButton>
    }

    render() {
        const {sazbyDphList, t} = this.props;
        let content;
        if (sazbyDphList.fetched) {
            if (sazbyDphList.rows.length !== 0) {
                content = sazbyDphList.rows.map(sazba => {
                    return <CardBody key={sazba.id} className={sazba.neaktivni ? "neaktivni" : ""}>
                        <ActionsRow actions={this.renderContextMenu(sazba)} onClick={this.handleEditSazbaDph.bind(this, sazba)}>
                            <Row>
                                <Col xs={COLUMN_WIDTH}>{sazba.nazevDph}</Col>
                                <Col xs={COLUMN_WIDTH}>{sazba.kodDph}</Col>
                                <Col xs={COLUMN_WIDTH}>{sazba.sazba}</Col>
                                <Col xs={COLUMN_WIDTH}>{sazba.neaktivni ? t('no') : t('yes')}</Col>
                            </Row>
                        </ActionsRow>
                    </CardBody>;
                });
            } else {
                content = <CardBody><i>{t('admin.no_vat_rate')}</i></CardBody>
            }
        } else {
            content = <Loader/>
        }
        const vcetneNeaktivnich = sazbyDphList.filter.vcetneNeaktivnich || false;
        return <AdminPage
            title={t('admin.vat_rates')}
            subtitle={t('admin.system_operator_vat_rates')}
            content={
                <div>
                    <ButtonToolbar>
                        <Button color="primary" onClick={this.handleCreateSazbaDph}>{t('new_f')}</Button>
                        <CustomCheckbox label={t('including_inactive')} value={vcetneNeaktivnich} onChange={this.handleVcetneNeaktivnich}/>
                    </ButtonToolbar>
                    <TablePanel header={
                        <Row>
                            <Col xs={COLUMN_WIDTH}>{t('labels.name')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('labels.code')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('rate')}</Col>
                            <Col xs={COLUMN_WIDTH}>{t('active')}</Col>
                        </Row>
                    }>
                        {content}
                    </TablePanel>
                </div>
            }
        />}
}

function mapStateToProps(state) {
    return {
        sazbyDphList: utils.storeFromArea(state, ciselnikActions.SAZBY_DPH_LIST_AREA),
    }
}

export default connect(mapStateToProps)(withTranslation()(SazbyDphPage));

